import Vue from 'vue';
import Vuex from 'vuex'; Vue.use(Vuex);
import sign from './modules/sign'
import site from './modules/site'
import header from './modules/header';
import ic_loader from './modules/ic-loader';
import auth from './modules/auth';
import myPageAndProfile from './modules/myPageAndProfile';
import errorHandling from './modules/errorHandling';

export default new Vuex.Store({
  modules: {
    sign,
    site,
    header,
    ic_loader,
    auth,
    myPageAndProfile,
    errorHandling
  }
});
